export const ROWS_PER_PAGE_LABEL = 'Results per page:';
